export default __webpack_public_path__ + "389d412a20951d5f13599d9fa5050f33.png";